import React, { PropsWithChildren, memo } from 'react'

import { Container, Grid, Space } from '@probatix/common/components/atoms'
import useSmallScreens from '@probatix/common/hooks/useSmallScreens'
import { CHECKOUT_MAX_WIDTH } from '@probatix/common/constants/design'

import { StyledAbsoluteFooter, StyledStickyFooter } from './StickyFooter.styled'

export type StickyFooterProps<T> = React.FC<T> & {
  $myProbatix?: boolean,
  children?: React.ReactNode,
  justifyContent?: string,
  leftButton?: React.ReactNode,
  rightButton?: React.ReactNode,
  sticky?: boolean
}

const StickyFooter: StickyFooterProps<PropsWithChildren<any>> = ({
  $myProbatix = false,
  children,
  justifyContent = 'space-between',
  leftButton,
  rightButton,
  sticky = true,
}) => {
  const [$isSmallScreen] = useSmallScreens()

  const renderGrid = () => (
    <Grid
      alignItems="center"
      data-testid="sticky-footer-grid"
      gridTemplateColumns="auto auto"
      justifyContent={justifyContent}
    >
      {leftButton && (
        <Grid.Item>
          {leftButton}
        </Grid.Item>
      )}
      {rightButton && (
        <Grid.Item>
          {rightButton}
        </Grid.Item>
      )}
    </Grid>
  )

  if (!sticky) {
    return (
      <React.Fragment>
        <Space space="40px" />
        <StyledAbsoluteFooter data-testid="absolute-footer">
          {renderGrid()}
        </StyledAbsoluteFooter>
      </React.Fragment>
    )
  }

  return (
    <StyledStickyFooter $isSmallScreen={$isSmallScreen} $myProbatix={$myProbatix} data-testid="sticky-footer">
      {!$isSmallScreen && <Space space="10px" />}
      <Container $maxWidth={CHECKOUT_MAX_WIDTH}>
        {children}
        {renderGrid()}
      </Container>
      {!$isSmallScreen && <Space space="10px" />}
    </StyledStickyFooter>
  )
}

export default memo(StickyFooter)
